import { createContext } from 'react';

import type { AuthContextState } from './AuthContext';

export type AuthActions = Pick<
  AuthContextState,
  | 'analyticsPrefix'
  | 'logIn'
  | 'register'
  | 'requestHumanStatus'
  | 'requestPasswordReset'
  | 'recordMarketingSmsConsent'
>;

export const AuthActionsContext = createContext<AuthActions | undefined>(undefined);
